import script from "./ResourceLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceLoader.vue?vue&type=script&setup=true&lang=js"

import "./ResourceLoader.vue?vue&type=style&index=0&id=e308990e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e308990e"]])

export default __exports__